// ViewAsBanner — Vista fiel (mandato Founder, jul-2026 · E2 rediseñado ·
// Iter 276: rediseño minimalista aprobado). El listón full-width de lado a
// lado fue ELIMINADO: ahora es un chip cápsula compacto, mismo lenguaje
// visual que la barra píldora (blur + fondo negro cálido), centrado 6px por
// encima de la píldora (ViewAsStrip, montado dentro de MobileNav — sube y
// baja junto con la barra). En pantallas SIN bottom nav, el fallback global
// muestra el mismo chip centrado abajo (jamás full-width).
// Puro indicador — la única vía de regreso sigue siendo el botón "Rol" del
// perfil propio (aprobado por el Founder).
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Eye } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { tr } from '@/contexts/LanguageContext';

const ROLE_LABELS = { barber: 'barbero', barbershop: tr("barbería"), client: 'cliente', brand: 'marca', judge: 'juez', admin: 'admin' };

const ViewAsChip = ({ label }) => (
  <div
    data-testid="view-as-banner"
    className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full"
    style={{
      background: 'rgba(10,10,10,0.78)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      border: '1px solid rgba(70,76,84,0.55)',
      boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
    }}
  >
    <Eye className="w-2.5 h-2.5 flex-shrink-0" style={{ color: '#C8CBD0' }} />
    <span
      className="text-[9px] uppercase tracking-[0.14em] font-semibold whitespace-nowrap"
      style={{ color: '#C8CBD0' }}
    >{tr("Viendo como {0}", label)}</span>
  </div>
);

/** Chip integrado dentro de MobileNav — flota 6px encima de la píldora. */
export const ViewAsStrip = () => {
  const { user } = useAuth();
  if (!user?.real_role || user.role === user.real_role) return null;
  return (
    <div className="w-full flex justify-center mb-1.5 pointer-events-none">
      <ViewAsChip label={ROLE_LABELS[user.role] || user.role} />
    </div>
  );
};

/** Fallback global: solo en pantallas SIN bottom nav (paneles fullscreen). */
export const ViewAsBanner = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [navPresent, setNavPresent] = useState(true);

  useEffect(() => {
    const id = setTimeout(() => {
      setNavPresent(!!document.querySelector('[data-testid="mobile-nav"]'));
    }, 250);
    return () => clearTimeout(id);
  }, [location.pathname]);

  if (!user?.real_role || user.role === user.real_role || navPresent) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 pointer-events-none flex justify-center pb-3 safe-area-inset-bottom">
      <ViewAsChip label={ROLE_LABELS[user.role] || user.role} />
    </div>
  );
};

export default ViewAsBanner;
